export const NOTIFICATION_CONSUMED = 'TAB_COMMUNICATION_NOTIFICATION_CONSUMED';
